import React, { useEffect, useRef, useState } from "react";
import image from '../assets/image-icon.png';
import { LeftCircleOutlined, RightCircleOutlined} from '@ant-design/icons';
import './controles.css';

export default function EscenasMenu({ escenas, setEscena, setShowCarrousel, hiddenScenasShortcut }){
    const [scrollPos, setScrollPos] = useState(0);
    const [isActive, setIsActive] = useState(false);



    useEffect(() => {      


        document.addEventListener('touchstart', handleOutsideTouch);

        return () => {
            document.removeEventListener('touchstart', handleOutsideTouch);
        };
    }, []);


    const setScroll = (right) => {
        const itemWidth = 100; // Width of each item including margin/padding
        const escenasCont = document.getElementById('escenasMenu');
        const maxScroll = (escenas.length * itemWidth) - escenasCont.clientWidth;
        
        let newScrollPos = right ? 
            Math.min(maxScroll, scrollPos + itemWidth) : 
            Math.max(0, scrollPos - itemWidth);
        
        setScrollPos(newScrollPos);
        escenasCont.scrollTo({
            left: newScrollPos,
            behavior: 'smooth'
        });
    }

    const iconStyle = { 
        fontSize: '64px', 
        color: 'white', 
        marginRight: 20,
        cursor: 'pointer',
        padding: '10px', // Área más grande para click/tap
        backgroundColor: 'rgba(0,0,0,0.3)', // Fondo semi-transparente
        borderRadius: '50%' // Hacer el área de click circular
    };

    const carouselRef = useRef(null);

    const handleOutsideTouch = (event) => {
        // Si el carrusel existe y el touch NO está dentro del carrusel
        if (carouselRef.current && !carouselRef.current.contains(event.target)) {
            hiddenScenasShortcut();
        }
    };
    
    return (
        <div 
        ref={carouselRef}
        id="escenasContainer" 
        className={`${!isActive ? 'hidden-scenes' : ''}`}        
        onMouseEnter={() => console.log('Mouse Enter')}
        onMouseLeave={hiddenScenasShortcut}                
    >
        <div className="navigation-controls">
            <LeftCircleOutlined 
                style={iconStyle} 
                onClick={(e) => {
                    e.stopPropagation();
                    setScroll(false);
                }}
            />
        </div>
        <div id="escenasMenu">
        {escenas && escenas.map((e, i) => 
                        <div key={i} class="escenaIcon">
                            <img className="escenaPic" key={i} width="80px" src={e.fondo} onClick={() => setEscena(e.titulo)}/>
                            <label>{e.titulo}</label>
                        </div>
                    )}
        </div>
        <div className="navigation-controls">
            <RightCircleOutlined 
                style={iconStyle} 
                onClick={(e) => {
                    e.stopPropagation();
                    setScroll(true);
                }}
            />
        </div>
    </div>
    )
 
}